import {ITheme} from 'contexts/ThemeContext';
import {Platform, StyleSheet, useWindowDimensions} from 'react-native';
import {isIphoneX} from 'react-native-iphone-x-helper';

const TABS_COUNT = 7;
const shadow = {
  shadowColor: '#000',
  shadowOffset: {
    width: 0,
    height: 2,
  },
  shadowOpacity: 0.23,
  shadowRadius: 2.62,

  elevation: 4,
};

export default (props: ITheme) => {
  const width = useWindowDimensions().width;

  return StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: props.colors.dirtyWhite,
    },

    greetingContainer: {
      marginTop: isIphoneX() ? 10 : 24,
      marginLeft: 15,
      marginRight: 30,
      flexDirection: 'row',
      justifyContent: 'space-between',
      paddingBottom: 24,
    },
    smallCalendarContainer: {
      width: '100%',
      paddingBottom: 20,
      paddingTop: 15,
      backgroundColor: props.colors.white,
      ...shadow,
    },
    smallCalendarDateTextStyle: {
      fontSize: 15,
      color: props.colors.cornflowerBlue,
      ...props.typography.interMedium,
    },
    dateAndButtonContainer: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginLeft: 16,
      marginRight: 0,
      backgroundColor: props.colors.white,
    },

    calendarImageAndTodayButtonContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      marginRight: 20,
      paddingRight: 0,
    },

    calendarImageContainer: {
      width: 25,
      height: 25,
      borderRadius: 8,
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: props.colors.white,
    },
    calendarImage: {
      width: 24,
      height: 24,
    },
    segmentedControlWrapper: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      borderRadius: 8,
      width: width,
      backgroundColor: props.colors.white,
      paddingVertical: 18,
    },

    segmentedControlButton: {
      ...StyleSheet.absoluteFillObject,
      position: 'absolute',
      width: 33,
      top: 0,
      height: 73,
      marginTop: 18,
      marginLeft: width / TABS_COUNT - 45,
      marginVertical: 2,
      backgroundColor: props.colors.cornflowerBlueWithOpacity(0.09),
      borderRadius: 27,
      ...(Platform.OS == 'ios' ? shadow : {}),
    },

    listTitleText: {
      marginVertical: 25,
      marginLeft: 15,
    },

    modalView: {
      justifyContent: 'flex-end',
      paddingBottom: 37,
    },
    flex: {
      flex: 1,
    },
    webContainer: {
      flex: 1,
      flexDirection: 'row',
    },
    webLeftPart: {
      width: 440,
      flexDirection: 'column',
      justifyContent: 'flex-start',
      backgroundColor: props.colors.dirtyWhite,
    },

    webRightPart: {
      flex: 1,
    },

    bigCalendarSize: {
      height: useWindowDimensions().height - 60,
    },
  });
};
